export default __webpack_public_path__ + "static/media/Advocacy.6218c2b1.png";